import { api } from '@/services';
import { connectAdminNotificationsSocket, disconnectAdminNotificationsSocket } from '@/services/adminNotificationsSocket';

function normalizeSocketPayload(payload) {
    if (!payload?.id) {
        return null;
    }
    return {
        id: payload.id,
        recipient_admin_id: payload.recipient_admin_id,
        actor_admin_id: payload.actor_admin_id,
        actor: {
            id: payload.actor_admin_id,
            first_name: payload.actor_first_name,
            last_name: payload.actor_last_name,
            email: '',
        },
        note_id: payload.note_id,
        resource_type: payload.resource_type,
        resource_id: payload.resource_id,
        resource_url: payload.resource_url,
        comment_preview: payload.comment_preview,
        comment_mention_labels: Array.isArray(payload.comment_mention_labels)
            ? payload.comment_mention_labels
            : [],
        viewed: Boolean(payload.viewed),
        created_at: payload.created_at,
    };
}

export default {
    namespaced: true,
    state: {
        unreadCount: 0,
        previewItems: [],
    },
    mutations: {
        setUnreadCount(state, n) {
            state.unreadCount = Math.max(0, Number(n) || 0);
        },
        setPreviewItems(state, items) {
            state.previewItems = Array.isArray(items) ? items : [];
        },
        unshiftNotification(state, item) {
            if (!item?.id) {
                return;
            }
            const withoutDup = state.previewItems.filter((row) => row.id !== item.id);
            state.previewItems = [item, ...withoutDup].slice(0, 30);
        },
        incrementUnread(state) {
            state.unreadCount += 1;
        },
        markOneViewedInPreview(state, id) {
            state.previewItems = state.previewItems.map((row) =>
                String(row.id) === String(id) ? { ...row, viewed: true } : row
            );
        },
    },
    actions: {
        async refresh({ commit }) {
            const [countRes, listRes] = await Promise.all([
                api.client.get('/_/admin-notifications/unread-count'),
                api.client.get('/_/admin-notifications', { params: { limit: 15, page: 1 } }),
            ]);
            commit('setUnreadCount', countRes.data?.count ?? 0);
            const listPayload = listRes.data;
            const items = Array.isArray(listPayload?.data) ? listPayload.data : [];
            commit('setPreviewItems', items);
        },
        async init({ dispatch }) {
            await dispatch('refresh');
            await dispatch('connectSocket');
        },
        async connectSocket({ commit, dispatch }) {
            await connectAdminNotificationsSocket((payload) => {
                const normalized = normalizeSocketPayload(payload);
                if (!normalized) {
                    return;
                }
                commit('unshiftNotification', normalized);
                commit('incrementUnread');
            }, {
                onResume() {
                    dispatch('refresh').catch((error) => {
                        console.error(error);
                    });
                },
            });
        },
        teardown() {
            disconnectAdminNotificationsSocket();
        },
        async markOneViewed({ commit, dispatch }, notificationId) {
            await api.client.patch(`/_/admin-notifications/${notificationId}/viewed`);
            commit('markOneViewedInPreview', notificationId);
            await dispatch('refresh');
        },
        async markAllViewed({ dispatch }) {
            await api.client.patch('/_/admin-notifications/mark-all-viewed');
            await dispatch('refresh');
        },
    },
};
